import { queryOptions, useQuery } from "@tanstack/react-query";
import { api } from "../apiClient";

export const deleteBusScheduleSimulate = ({ busCourseId, id }) => {
  return api.delete(
    `/admin/bus-courses-v2/${busCourseId}/schedules/simulate/${id}`
  );
};

export const deleteBusScheduleSimulateQueryOptions = data => {
  return queryOptions({
    queryKey: ["delete-bus-schedule-simulate", data],
    queryFn: () => deleteBusScheduleSimulate(data),
  });
};

export const useDeleteBusScheduleSimulate = ({ queryConfig, ...data } = {}) => {
  return useQuery({
    ...deleteBusScheduleSimulateQueryOptions(data),
    ...queryConfig,
  });
};
